import React from 'react';

import type { IVMMethods } from '../../../vm/types';

export const ControllerContext = React.createContext<IVMMethods>(
  {} as IVMMethods,
);
